module.exports = __webpack_public_path__ + "img/thumbnail_Nilgai_j_leucistic.957136ae.png";